module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/102/assets/images/56d1cabbf61350b5677d4c8735b4facc.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_collapse.svg
// module id = Fnus
// module chunks = 0